// Module
var code = "<div class=\"skeleton\"> <ng-transclude></ng-transclude> </div> ";
// Exports
module.exports = code;